// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__LlElU","title":"InfoRow_title__1PLYX"};